export const SET_EDUCATION_LEVEL = "SET_EDUCATION_LEVEL";
export const SET_REGIONS = "SET_REGIONS";

export const SET_ALL_DOCUMENT_SPECS = "SET_ALL_DOCUMENT_SPECS";
export default {
  SET_EDUCATION_LEVEL,
  SET_REGIONS,
  SET_ALL_DOCUMENT_SPECS,
};
